var map = {
	"./SSM/hero.png": 79,
	"./canvas/hero.png": 80,
	"./deudafix/hero.png": 81,
	"./fleetlink/hero.png": 82,
	"./fotoblic/hero.png": 83,
	"./goundrys/hero.png": 84,
	"./hjertekampen/hero.png": 85,
	"./kreola/hero.png": 86,
	"./mame/hero.png": 87,
	"./nucleus/hero.png": 88,
	"./vault/hero.png": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;